import styled, { css } from 'styled-components'
import { Box } from '../../UI/Box'
import { withIndexGutters } from '../../../theme'

export const overflowingCarouselCssRules = css<{ maxWidth?: number }>`
  overflow-x: auto;
  min-width: ${({ maxWidth }) => (!!maxWidth ? `${maxWidth}px` : '100vw')};
  padding-right: calc(100vw - 100%);
`

export const OverflowingCarousel = styled(Box)<{
  indexGutters?: boolean
  maxWidth?: number
}>`
  ${overflowingCarouselCssRules}
  ${withIndexGutters}
`
